import { cloneDeep } from "lodash";
import { initialState } from "../initialState";
import { tagActions as actions } from "../actions";
import { createReducer, methodSwitcher } from "./utilities";

const { tag } = initialState;

const clearCurrent = (state) => ({ ...state, current: {} });

const setTagList = (state, { data }) => {
  const newState = cloneDeep(state);
  newState.list = data;
  return newState;
};

const setCurrentTag = (state, { data }) => {
  const newState = cloneDeep(state);
  newState.current = data;
  return newState;
};

const actionTag = (state, { data, id, method }) => {
  const newState = cloneDeep(state);
  methodSwitcher(newState, data, id, method);
  return newState;
};

export const tagReducer = createReducer(tag, {
  [actions.CLEAR_CURRENT]: clearCurrent,
  [actions.LIST]: setTagList,
  [actions.CURRENT]: setCurrentTag,
  [actions.CUD]: actionTag,
});
